<angular-editor id="about" [(ngModel)]="content" [config]="editorConfig" (ngModelChange)="contentChanged()"></angular-editor>
